const common = {
  nav: {
    about: 'Chi Sono',
    services: 'Servizi',
    credentials: 'Credenziali',
    contact: 'Contatti',
    insights: 'Riflessioni',
    cta: 'Prenota una Consulenza',
  },
  footer: {
    badge: 'Analista di Gruppo Clinica',
    tagline: 'Unire una profonda intuizione psicologica con la realtà organizzativa pratica. Con sede a Tirana, al servizio di clienti a livello internazionale.',
    navTitle: 'Navigazione',
    about: 'Chi Sono',
    services: 'Servizi Offerti',
    credentials: 'Credenziali',
    contact: 'Contatti',
    affiliations: 'Affiliazioni Professionali',
    iga: 'Istituto di Analisi di Gruppo (IGA)',
    igaProgram: 'Programma Internazionale UK',
    location: 'Tirana, Albania',
    languages: 'Inglese · Italiano · Albanese',
    copyright: '© 2026 Mirela. Tutti i diritti riservati.',
  },
  about: {
    hero: {
      badge: 'Consulente & Psicoterapeuta\nSistemi, Gruppi e Dinamiche Organizzative',
      heading: 'Ciao, mi chiamo Mirela Bregu. Sono una consulente organizzativa e una terapeuta di gruppo certificata.',
      intro: 'Una pratica fondata su decenni di esperienza all\'intersezione tra sviluppo personale, business e sistemi umani — al servizio di clienti a Tirana e a livello internazionale.',
      cta1: 'Contattami',
      cta2: 'Scopri i Servizi',
      stat1: 'Anni di Esperienza',
      stat2: 'Lingue Parlate',
      stat3: 'Certificata IGA',
      locationLabel: 'Sede dello Studio',
      locationValue: 'Tirana, Albania',
    },
    bg: {
      badge: 'Background',
      headlinePart1: 'Decenni all\'intersezione tra',
      headlineEm: 'business e comportamento umano',
      p1: 'La mia carriera è stata definita da un profondo interesse per come le persone funzionano in ambienti strutturati. Ho trascorso decenni nel business development, nel coordinamento di progetti e nella gestione organizzativa — ruoli che richiedono una profonda comprensione del comportamento umano, della comunicazione e della salute sistemica.',
      p2: 'Non vedo gli individui in isolamento; vedo le reti, le storie e i gruppi che li formano. Questa prospettiva sistemica informa ogni aspetto della mia pratica clinica.',
      trainingBadge: 'Formazione e Credenziali',
      trainingText: 'Sono una esperta clinica formata dall\'Istituto di Analisi di Gruppo (IGA), Programma Internazionale UK. Questa formazione rigorosa, combinata con la mia vasta esperienza nel settore professionale, mi permette di colmare il divario tra profonde intuizioni psicologiche e la realtà organizzativa pratica.',
      verified: 'Analista di Gruppo · Certificata IGA',
      practiceBadge: 'Studio',
      practiceText: 'Il mio studio è a Tirana, dove servo una clientela diversificata in inglese, italiano e albanese — offrendo uno spazio internazionalmente informato ma radicato localmente.',
    },
    approach: {
      badge: 'Il Mio Approccio',
      quote: 'Vedo le sfide come l\'ansia, il burnout o il conflitto come segnali di problemi sistemici più profondi — non problemi da gestire, ma verità da comprendere.',
      s1Title: 'Dinamiche Organizzative',
      s1Desc: 'Scoprire le forze invisibili che plasmano la cultura del lavoro e il comportamento di gruppo.',
      s2Title: 'Coaching per la Leadership',
      s2Desc: 'Uno spazio riservato per i leader per elaborare il peso psicologico del processo decisionale.',
      s3Title: 'Problemi Relazionali',
      s3Desc: 'Esplorare i modelli relazionali nei contesti individuali e di coppia.',
      s4Title: 'Coesione di Gruppo',
      s4Desc: 'Favorire fiducia, comunicazione e senso di appartenenza all\'interno di team e comunità.',
      s5Title: 'Crescita Personale',
      s5Desc: 'Supportare trasformazioni durature attraverso l\'auto-riflessione e la visione sistemica.',
      s6Title: 'Ambiente di Contenimento',
      s6Desc: 'Uno spazio sicuro, riservato e trasparente per esplorare verità difficili senza giudizio.',
      method: 'Il mio approccio si basa principalmente sulla Psicoterapia Psicoanalitica di Gruppo. Nelle sessioni facilito un processo di libera associazione e riflessione. Per i clienti organizzativi utilizzo il pensiero Sistemi-Psicodinamico per aiutarvi a vedere le forze invisibili nella cultura del vostro luogo di lavoro. Non ci concentriamo solo sui sintomi immediati — esploriamo la vita inconscia del gruppo o dell\'individuo.',
    },
    cred: {
      iga: 'Istituto di Analisi di Gruppo (IGA), UK',
      languages: 'Inglese · Italiano · Albanese',
      location: 'Studio a Tirana, Albania',
    },
  },
  services: {
    hero: {
      badge: 'Cosa Offro',
      title: 'Servizi Offerti',
      subtitle: 'Iniziare una terapia o una consulenza è un passo significativo verso la comprensione di sé. Che tu sia un individuo, una coppia o un\'organizzazione, offro uno spazio rigoroso, compassionevole e basato su prove.',
    },
    sectionBadge: 'Specializzazioni Principali',
    c1Tag: 'Offerta Principale',
    c1Title: 'Psicoterapia Psicoanalitica di Gruppo',
    c1Desc: 'Sessioni settimanali per individui che desiderano esplorare i propri schemi relazionali in un contesto di gruppo supportivo. Il gruppo diventa un microcosmo del mondo sociale, un luogo per capire sé stessi attraverso gli altri.',
    c2Tag: 'Individuale',
    c2Title: 'Terapia Psicodinamica Individuale',
    c2Desc: 'Lavoro individuale focalizzato su transizioni personali, identità e benessere emotivo.',
    c3Tag: 'Organizzazioni',
    c3Title: 'Organisational Dynamics',
    c3Desc: 'Supporto specializzato per leader e team per migliorare la coesione di gruppo, la comunicazione e la salute organizzativa attraverso una lente sistemi-psicodinamica.',
    c4Tag: 'Leadership',
    c4Title: 'Leadership\u00a0Coaching and\u00a0Reflective Practice\u00a0',
    c4Desc: 'Uno spazio riservato per i dirigenti per elaborare il peso psicologico della leadership, la responsabilità strategica e l\'isolamento che spesso accompagna il processo decisionale. When needed, through the use of International Preferences Indicator (IPI), and The International Profile (TIP)',
    c5Tag: 'Professionisti',
    c5Title: 'Supervisione e Mentorship',
    c5Desc: 'Supporting professionals to enhance their practice through a systemic and group-analytic lens.',
    dir: {
      badge: 'Elenco Completo',
      offered: 'Servizi Offerti',
      worksWith: 'Lavora Con',
      areas: 'Aree di Competenza',
      profTitle: 'Titolo Professionale',
      groupAnalyst: 'Analista di Gruppo',
      servicesList: ['Coaching', 'Gestione dei Conflitti', 'Consulenza', 'Workshop Aziendali', 'Terapia di Gruppo', 'Psicoterapia Individuale', 'Terapia Online', 'Consulenza Relazionale', 'Supervisione e Formazione', 'Gruppi di Supporto'],
      workList: ['Adulti', 'Comunità', 'Coppie', 'Anziani', 'Famiglie', 'Gruppi', 'Organizzazioni', 'Genitori', 'Individui'],
      areasList: ['Ansia', 'Problemi di Carriera', 'Cross-Culturale', 'Gestione del Divorzio', 'Problemi Familiari', 'Senso di Colpa o Perdono', 'Transizioni di Vita', 'Supporto Genitoriale', 'Stress / Burnout', 'Autostima'],
    },
    fees: {
      badge: 'Tariffe e Info Sessioni',
      headline: 'Chiaro, flessibile e accessibile',
      subtext: 'Starting therapy or consultancy is a significant step toward self-understanding. If you are looking for a therapist who understands the complex interplay between the individual and the group, I invite you to reach out for an initial consultation.',
      type1Label: 'Terapia Psicodinamica Individuale',
      type1Duration: 'Sessioni da 50 minuti',
      type1Frequency: 'Settimanale o bisettimanale',
      type1Format: 'Di persona (Tirana) o online',
      type2Label: 'Psicoterapia Psicoanalitica di Gruppo',
      type2Duration: 'Sessioni da 90 minuti',
      type2Frequency: 'Settimanale — gruppo continuativo',
      type2Format: 'Di persona (Tirana) o online',
      type3Label: 'Consulenza Organizzativa',
      type3Duration: 'Durata su misura',
      type3Frequency: 'Adattata all\'ambito del progetto',
      type3Format: 'In sede o online',
      type4Label: 'Pratica Riflessiva per la Leadership',
      type4Duration: 'Sessioni da 60 minuti',
      type4Frequency: 'Settimanale o quindicinale consigliato',
      type4Format: 'Di persona o online',
      feeNoticeTitle: 'Una nota sulle tariffe',
      feeNoticeText: 'Le tariffe variano in base al tipo di servizio, alla frequenza delle sessioni e alle circostanze individuali. Il mio obiettivo è essere trasparente e accessibile — se hai preoccupazioni riguardo all\'accessibilità economica, ti incoraggio a sollevarle durante la nostra conversazione iniziale.',
      feeNoticeNote: 'In alcuni casi potrebbero essere disponibili tariffe ridotte. Si prega di contattarmi direttamente.',
      introTitle: 'Consultazione Iniziale Gratuita',
      introText: 'A complimentary 30-minute introductory consultation to discuss your needs, ask questions, and explore whether my approach is the right fit for you. The consultation can be held in presence or online.',
      introBtn: 'Prenota la tua chiamata gratuita',
      onlineTitle: 'Disponibile Online',
      onlineText: 'Tutte le sessioni individuali e di coaching sono disponibili tramite videochiamata sicura per clienti in tutta Europa e a livello internazionale.',
    },
    cta: {
      title: 'Pronto a Iniziare?',
      desc: 'Se stai cercando un terapeuta che comprenda la complessa interazione tra individuo e gruppo, ti invito a contattarmi per una consultazione iniziale.',
      btn: 'Arrangia una Consulenza',
    },
  },
  contact: {
    hero: {
      badge: 'Contattaci',
      title: 'Entra in Contatto',
      subtitle: 'Fai una domanda veloce o organizza un appuntamento. Rispondo entro 48 ore.',
    },
    form: {
      name: 'Nome Completo',
      namePlaceholder: 'Il tuo nome',
      email: 'Indirizzo Email',
      emailPlaceholder: 'tu@esempio.com',
      phone: 'Numero di Telefono',
      phoneOptional: '(opzionale)',
      phonePlaceholder: '+355 XX XXX XXXX',
      service: 'Servizio di Interesse',
      serviceDefault: 'Seleziona un servizio…',
      service1: 'Psicoterapia Psicoanalitica di Gruppo',
      service2: 'Terapia Psicodinamica Individuale',
      service3: 'Consulenza Organizzativa',
      service4: 'Pratica Riflessiva per la Leadership',
      service5: 'Supervisione e Mentorship',
      service6: 'Non sono sicuro/a',
      preferred: 'Metodo di Contatto Preferito',
      contactEmail: 'Email',
      contactPhone: 'Telefono',
      contactEither: 'Entrambi',
      message: 'Messaggio',
      messagePlaceholder: 'Fai una domanda o raccontami brevemente cosa stai cercando…',
      submit: 'Invia Messaggio',
      sending: 'Invio in corso…',
      privacy: 'Le tue informazioni sono riservate e non saranno condivise.',
      successTitle: 'Messaggio Inviato',
      successDesc: 'Grazie per avermi contattato. Ti risponderò a breve per organizzare un appuntamento.',
      successBtn: 'Invia un Altro Messaggio',
      error: 'Qualcosa è andato storto. Per favore riprova o contattami direttamente.',
    },
    info: {
      email: 'Email',
      phone: 'Telefono',
      location: 'Posizione',
      langTitle: 'Lingue',
      availTitle: 'Disponibilità',
      availText: 'Sessioni disponibili di persona a Tirana e online per clienti internazionali. Le consultazioni iniziali sono disponibili su appuntamento.',
    },
    loc: {
      badge: 'Sede dello Studio',
      title: 'Con sede a Tirana, al servizio di clienti a livello internazionale',
      text: 'Lo studio è situato a Tirana, Albania. La terapia online e la consulenza sono disponibili per clienti in tutta Europa e oltre. Tutte le sessioni sono strettamente riservate.',
    },
  },
  coreCompetencies: {
    badge: 'Core Competencies',
    quote: "We don't live or work in isolation; we exist within 'constellations, our families, our teams, and within our organizations.",
    paragraph: "My approach is primarily Group Psychoanalytic Psychotherapy with specializations in: Organizational Dynamics, Leadership Coaching, Relationship Issues, Group Cohesion, and Personal Growth. We don't just focus on immediate symptoms; we look at the 'unconscious' life of the group or the individual. I view challenges like anxiety, burnout, or conflict as signals of deeper systemic issues.",
    c1Title: 'Institutional Building & Governance',
    c1Desc: 'Establishing professional, merit-based cultures and aligning executive teams using advanced coaching and group dynamics tools.',
    c2Title: 'Development Banking',
    c2Desc: 'Scaling financial operations from simple product offices to full commercial business lines, grounded in the ProCredit and Intesa Sanpaolo models.',
    c3Title: 'Organizational Transformation & Performance',
    c3Desc: 'Leading large-scale cultural shifts and re-engineering business processes to increase institutional agility and performance.',
    c4Title: 'Leadership Development',
    c4Desc: 'Understanding the needs of Executive & Team Performance for Coaching and support, to accelerate leadership capabilities and institutional cohesion.',
  },
  education: {
    badge: 'Education',
    certsBadge: 'Advanced Certifications',
    academicBadge: 'Academic & Volunteer Experience',
    academicText: 'Early in my career, I served as a Seminar Leader at the University of Tirana, teaching Basis of Marketing and International Business, before going on to chair the Board of Junior Achievement Albania. I subsequently led seminars in Credit Management and Bank Simulation at FASTIP, Aleksander Moisiu University, and currently serve as General Secretary of Group Analysis Albania — a non-profit member of GASI and EGATIN.',
    d1Degree: 'Qualified Group Analyst (QGA)',
    d1Institution: 'Institute of Group Analysis (IGA)',
    d1Location: 'London',
    d1Period: '2019 – 2024',
    d2Degree: 'Master of Business Administration (MBA)',
    d2Institution: 'University of Nebraska-Lincoln / University of Tirana',
    d2Period: '2002 – 2004',
    d3Degree: "Bachelor's Degree in Finance",
    d3Institution: 'University of Tirana',
    d3Period: '1991 – 1995',
    cert1Title: 'The International Profiler (TIP – next gen)',
    cert1Issuer: 'Global Agility Tools',
    cert2Title: 'International Preferences Indicator (IPI next gen)',
    cert2Issuer: 'Global Agility Tools',
    cert3Title: 'Digital Business & Entrepreneurial Toolbox',
    cert3Issuer: 'EBRD',
    cert4Title: 'Change Management for Consulting',
    cert4Issuer: 'EBRD',
    cert5Title: 'Foundation Course in Group Analysis',
    cert5Issuer: 'IGA Accredited',
    cert6Title: 'Harvard ManageMentor',
    cert6Issuer: 'Harvard Business Publishing',
  },
  experience: {
    badge: 'Working Experience',
    j1Title: 'Consultant (Albania)',
    j1Org: 'FBI Consulting ShPK',
    j1Period: 'October 2017 – Present',
    j1b1: 'Managed organizational restructuring and change management, optimizing job descriptions and incentive/bonus systems.',
    j1b2: 'Assisted Startups and SMEs with adapting business strategy, understanding customer base, and re-engineering internal workflows and processes between different functional departments.',
    j1b3: 'Employed Group-analysis methodology to facilitate dialogue and organizational health. Provided psychotherapy/coaching to individuals and groups.',
    j2Title: 'Head of Retail Banking Division (Albania)',
    j2Org: 'Tirana Bank – PIRAEUS BANK Group',
    j2Period: 'November 2013 – June 2017',
    j2b1: 'Developed and implemented the Retail Strategy and Action-Plans, managing all retail banking activities: Products & Services, Cards & Electronic-channels, and Marketing.',
    j2b2: 'Re-engineered processes and workflows through product mix optimization and introduction of incentives to boost sales.',
    j2b3: 'Evaluated procedures and processes at Branch and Division levels to ensure efficiency, effectiveness, and compliance with internal policies and regulatory requirements.',
    j3Title: 'Executive Director (Uganda)',
    j3Org: 'PEARL MICROFINANCE',
    j3Period: 'July 2012 – March 2013',
    j3b1: 'Led the turnaround project of the institution (14 branches, 140 employees) facing limited resources, achieving break-even within a 4-month timeframe.',
    j3b2: 'Improved institutional culture and led the reorganization/creation of several key departments (legal, administration, operations).',
    j3b3: 'Built capacity by introducing training programs, incentive payment schemes, and implementing mobile money payment systems.',
    j3b4: 'Successfully implemented a new MIS with detailed processes/procedures and proper data migration.',
    j4Title: 'Senior Consultant, Principal (Projects in Pacific Islands, Uganda, Ghana)',
    j4Org: 'A2F Consulting',
    j4Period: 'October 2011 – June 2012',
    j4b1: 'Provided strategy, advisory, and operational consulting focusing on process re-engineering, change management, and product mix optimization.',
    j4b2: 'Implemented tools for liquidity management, loan monitoring, and credit risk management, and developed department reporting frameworks.',
    j5Title: 'Manager-Coordinator of Retail Team (Bank of Qingdao Project, China)',
    j5Org: 'INTESA SANPAOLO S.p.A., ISBD',
    j5Period: '2009 – 2011',
    j5b1: 'Provided know-how and capacity building to foster the Retail Business Development of the Bank of Qingdao (BQD).',
    j5b2: 'Revised, differentiated, and enriched the basic product catalog by analyzing customer base and usage rates.',
    j5b3: 'Designed the appropriate Retail Service Model and led the development of the internal structure from simple transaction offering to full service/advisory.',
    j5b4: 'Led the development of the common branch layout model, basic branch revamping, and standardized the process for BTL marketing materials.',
    j6Title: 'Consultant, Retail Business Development Office',
    j6Org: 'INTESA SANPAOLO S.p.A., ISBD (Italy)',
    j6Period: '2008 – 2009',
    j6b1: 'Coordinated Retail activities and strategies across the International Subsidiary Banks Division (ISBD) scope of project.',
    j6b2: "Supported the launch of innovative products/services and propagated ISP Group's Best Practices.",
    j7Title: 'Manager, Network Expansion',
    j7Org: 'INTESA SANPAOLO Bank Albania (former ABA, Albania)',
    j7Period: '2004 – 2007',
    j7b1: 'Responsible for all aspects of planning, coordinating, and ensuring successful bank expansion.',
    j7b2: 'Managed Geo-Market study, negotiated legal contracts, supervised construction, and coordinated all internal departments and third parties (local government, Central Bank).',
    j8Title: 'Earlier Career',
    j8Org: 'INTESA SANPAOLO Bank Albania',
    j8Period: '2002 – 2008',
    j8b1: 'Held roles as: Manager Statistics and Reporting Card, Services Department; Supervisor, Compliance Operations; Internal Audit.',
    j9Title: 'Earlier Career',
    j9Org: 'PROCREDIT Group (Albania)',
    j9Period: '1996 – 2002',
    j9b1: 'Held roles as: Regional Manager, Micro LO, SME LO, and Branch Manager.',
    j9b2: 'Coordinated, controlled, and decided on all operational issues within the region.',
    j9b3: 'Planned, selected, and evaluated regional staff, and ensured the achievement of targets set by management.',
  },
  insights: {
    hero: {
      badge: 'Riflessioni e Scrittura',
      title: 'Riflessioni',
      subtitle: 'Riflessioni sulle dinamiche di gruppo, sulla vita organizzativa e sul funzionamento interno della mente — originariamente condivise su LinkedIn.',
      linkedinCta: 'Segui su LinkedIn',
    },
    featuredLabel: 'In Evidenza',
    readMore: 'Continua a leggere',
    minRead: 'min di lettura',
    filterAll: 'Tutti',
    empty: 'Nessun articolo trovato in questa categoria.',
    watchVideo: 'Guarda il video',
    includesVideo: 'Include video',
    viewOnLinkedIn: 'Visualizza il post originale su LinkedIn',
    ctaTitle: 'Altro su LinkedIn',
    ctaSubtext: 'Segui Mirela su LinkedIn per ricevere nuove riflessioni e aggiornamenti professionali non appena vengono pubblicati.',
    ctaBtn: 'Segui su LinkedIn',
  },
};

export default common;
